import * as Yup from "yup";
import { useFormik } from "formik";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import { AiOutlineClose } from "react-icons/ai";
import ButtomButton from "../../DocButtomButton";
import CustomInput from "../../CustomEditInput";
import { updateFee } from "../../../actions/fee.action";
import ErrorInputComponent from "../../ErrorInputComponent";
import { Loading } from "../../../utils/helpers/constants";
import DropDownInput from "../../DropDownInput";
import EnumDropDownInput from "../../EnumDropDownInput";
import { feeTypes } from "../../../utils/mapper/mappers";

export default function EditAnnouncementModal({
  item,
  open,
  setOpen,
  cancelButtonRef,
}) {
  const dispatch = useDispatch();

  const {
    fee: { feeLoading },
    payment: { currencies, currencyLoading },
  } = useSelector(({ feeReducer, paymentReducer }) => ({
    fee: feeReducer,
    payment: paymentReducer,
  }));

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      fee: item.fee,
      feeType: item.feeType,
      currencyCode: item.currencyCode,
    },
    onSubmit(values) {
      const payload = {
        fee: values.fee,
        feeType: values.feeType,
        currencyCode: values.currencyCode,
      };
      dispatch(updateFee(item.id, payload));
    },
  });

  const buttonLoadState = feeLoading === Loading.FETCHING;
  const loadState = currencyLoading === Loading.SUCCESS;

  console.log({ currencies });
  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-cente justify-center min-h-full p-4 text-cente sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-cente overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="">
                    <div className="">
                      <div className="mb-6 bg-gray-800 p-4 rounded-t-md">
                        <div className="flex text-xl items-center text-white">
                          <AiOutlineClose
                            onClick={() => setOpen(false)}
                            className="cursor-pointer"
                          />
                          <div className="ml-auto mr-auto font-bold">
                            Edit Announcement
                          </div>
                        </div>
                      </div>
                      <div className="mt-10 sm:px-6 px-6 w-full">
                        <form>
                          <DropDownInput
                            placeholder="Fee Type"
                            name="feeType"
                            handleChange={handleChange}
                            list={feeTypes}
                            defaultValue={item.feeType}
                            readOnly={true}
                          />
                          <ErrorInputComponent error={errors.feeType} />

                          <div className="flex gap-2 mb-2">
                            <div className="w-full">
                              <CustomInput
                                handleChange={handleChange}
                                name="fee"
                                placeholder="Amount"
                                type="number"
                                value={item.fee}
                              />
                              <ErrorInputComponent error={errors.fee} />
                            </div>
                            <div className="w-full">
                              <EnumDropDownInput
                                placeholder="Currency"
                                name="currencyCode"
                                handleChange={handleChange}
                                list={currencies}
                                defaultValue={item.currencyCode}
                              />
                              <ErrorInputComponent
                                error={errors.currencyCode}
                              />
                            </div>
                          </div>
                        </form>
                      </div>
                      <ButtomButton
                        name={"Update"}
                        func={handleSubmit}
                        loading={buttonLoadState}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
